(function () {
  function formatMoney(cents) {
    var format =
      (window.PXUTheme &&
        window.PXUTheme.currency &&
        window.PXUTheme.currency.money_format) ||
      '£{{amount}}';
    var amount = (Number(cents) / 100).toFixed(2);
    return format
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
  }

  function initProductMain(root) {
    if (!root || root.dataset.repolishedProductReady === 'true') return;
    root.dataset.repolishedProductReady = 'true';

    var jsonEl = root.querySelector('[data-product-json]');
    var product = null;
    if (jsonEl) {
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        product = null;
      }
    }

    var featured = root.querySelector('[data-featured-image]');
    var featuredLink = root.querySelector('[data-featured-link]');
    var thumbsWrap = root.querySelector('[data-thumbs]');
    var thumbsTrack = root.querySelector('[data-thumbs-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var thumbsPrev = root.querySelector('[data-thumbs-prev]');
    var thumbsNext = root.querySelector('[data-thumbs-next]');
    var galleryPrev = root.querySelector('[data-gallery-prev]');
    var galleryNext = root.querySelector('[data-gallery-next]');
    var stage = root.querySelector('.repolished-product-main__stage');
    var enableZoom =
      stage && stage.getAttribute('data-enable-zoom') === 'true';
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var variantSelect = root.querySelector('[data-variant-select]');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price-amount]');
    var compareEl = root.querySelector('[data-compare-amount]');
    var compareWrap = root.querySelector('[data-compare]');
    var klarnaAmount = root.querySelector('[data-klarna-amount]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    if (!addBtn) addBtn = root.querySelector('.repolished-btn.button--add-to-cart');
    var installments = Number(root.dataset.klarnaInstallments || 3);
    var isThumbSlider =
      thumbsWrap && thumbsWrap.dataset.thumbsLayout === 'slider';

    function getActiveThumbIndex() {
      var activeIndex = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains('is-active');
      });
      return activeIndex < 0 ? 0 : activeIndex;
    }

    function clearFeaturedInlineSize(img) {
      if (!img) return;
      img.style.removeProperty('width');
      img.style.removeProperty('height');
      img.style.removeProperty('max-width');
      img.style.removeProperty('max-height');
      img.style.removeProperty('display');
      img.style.removeProperty('margin');
      img.style.removeProperty('object-fit');
      img.style.removeProperty('transform');
      img.style.removeProperty('transform-origin');
      img.style.removeProperty('opacity');
      img.style.removeProperty('position');
      img.style.removeProperty('top');
      img.style.removeProperty('left');
    }

    function destroyHoverZoom() {
      if (!featured) return;
      featured.classList.remove('is-zooming');
      if (featured._rrZoomMove) {
        featured.removeEventListener('mousemove', featured._rrZoomMove);
        featured._rrZoomMove = null;
      }
      if (featured._rrZoomLeave) {
        featured.removeEventListener('mouseleave', featured._rrZoomLeave);
        featured._rrZoomLeave = null;
      }
      // Remove any leftover jquery.zoom markup from earlier versions
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.zoom) {
        var $ = window.jQuery;
        $(featured)
          .find('.zoom-container, .image-element__wrap, .repolished-product-main__image-wrap')
          .add(featured)
          .each(function () {
            $(this).trigger('zoom.destroy');
          });
      }
      featured.querySelectorAll('.zoomImg').forEach(function (el) {
        el.remove();
      });
      var img = featured.querySelector('img');
      if (img && img.parentElement && img.parentElement.classList.contains('zoom-container')) {
        var container = img.parentElement;
        var parent = container.parentElement;
        if (parent) {
          parent.insertBefore(img, container);
          container.remove();
        }
      }
      clearFeaturedInlineSize(img);
    }

    function initHoverZoom() {
      if (!enableZoom || !featured) return;
      // Skip artificial hover-zoom on coarse pointers (phones)
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

      var img = featured.querySelector('img');
      if (!img) return;

      destroyHoverZoom();
      img = featured.querySelector('img');
      if (!img) return;
      clearFeaturedInlineSize(img);

      var scale = 1.85;

      function onMove(event) {
        var rect = featured.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        featured.classList.add('is-zooming');
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(' + scale + ')';
      }

      function onLeave() {
        featured.classList.remove('is-zooming');
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      }

      featured._rrZoomMove = onMove;
      featured._rrZoomLeave = onLeave;
      featured.addEventListener('mousemove', onMove);
      featured.addEventListener('mouseleave', onLeave);
    }

    function scheduleHoverZoom() {
      if (!enableZoom || !featured) return;
      var zoomTimer = null;

      function runZoom() {
        if (zoomTimer) window.clearTimeout(zoomTimer);
        zoomTimer = window.setTimeout(initHoverZoom, 80);
      }

      var img = featured.querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', runZoom, { once: true });
        window.setTimeout(runZoom, 400);
        return;
      }
      runZoom();
    }

    function setFeatured(src, alt, options) {
      if (!featured || !src) return;
      var opts = options || {};
      destroyHoverZoom();
      var img = featured.querySelector('img');
      if (img && img.tagName === 'IMG') {
        img.classList.remove('lazyload', 'lazyloading', 'lazyloaded', 'transition--blur-up');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');
        var hiRes = opts.zoomSrc || opts.lightboxSrc || src;
        img.srcset =
          src + ' 2000w, ' + hiRes + ' 2400w';
        var maxW =
          getComputedStyle(root).getPropertyValue('--rr-product-image-max-width').trim() ||
          '720px';
        img.sizes = '(min-width: 1024px) min(50vw, ' + maxW + '), 92vw';
        img.src = src;
        if (alt) img.alt = alt;
        clearFeaturedInlineSize(img);
      }
      if (featuredLink) {
        featuredLink.href = '#product-image-lightbox';
        if (opts.lightboxSrc) {
          featuredLink.setAttribute('data-lightbox-href', opts.lightboxSrc);
        }
        if (alt) featuredLink.setAttribute('data-caption', alt);
      }
      if (opts.imageId) {
        featured.setAttribute('data-image-id', String(opts.imageId));
      }
      if (opts.zoomSrc) {
        featured.setAttribute('data-zoom-src', opts.zoomSrc);
      } else if (opts.lightboxSrc) {
        featured.setAttribute('data-zoom-src', opts.lightboxSrc);
      }
      scheduleHoverZoom();
    }

    function selectThumb(thumb, scrollIntoView) {
      if (!thumb) return;
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      setFeatured(thumb.dataset.imageSrc, thumb.dataset.imageAlt, {
        lightboxSrc: thumb.dataset.imageLightbox || thumb.dataset.imageSrc,
        zoomSrc:
          thumb.dataset.imageZoom ||
          thumb.dataset.imageLightbox ||
          thumb.dataset.imageSrc,
        imageId: thumb.dataset.imageId,
      });
      if (scrollIntoView !== false) scrollThumbIntoView(thumb);
    }

    function stepGallery(direction) {
      if (!thumbs.length) return;
      var current = getActiveThumbIndex();
      var next = (current + direction + thumbs.length) % thumbs.length;
      selectThumb(thumbs[next], true);
    }

    function scrollThumbIntoView(thumb) {
      if (!isThumbSlider || !thumbsTrack || !thumb) return;
      thumb.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'nearest',
      });
    }

    function updateThumbNav() {
      if (!isThumbSlider || !thumbsTrack || !thumbsPrev || !thumbsNext) return;
      var maxScroll = thumbsTrack.scrollWidth - thumbsTrack.clientWidth;
      thumbsPrev.disabled = thumbsTrack.scrollLeft <= 4;
      thumbsNext.disabled = thumbsTrack.scrollLeft >= maxScroll - 4;
    }

    function scrollThumbs(direction) {
      if (!thumbsTrack) return;
      var amount = Math.max(thumbsTrack.clientWidth * 0.8, 120);
      thumbsTrack.scrollBy({
        left: direction * amount,
        behavior: 'smooth',
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        selectThumb(thumb, true);
      });
    });

    if (galleryPrev) {
      galleryPrev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepGallery(-1);
      });
    }
    if (galleryNext) {
      galleryNext.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepGallery(1);
      });
    }

    if (isThumbSlider) {
      if (thumbsPrev) {
        thumbsPrev.addEventListener('click', function () {
          scrollThumbs(-1);
        });
      }
      if (thumbsNext) {
        thumbsNext.addEventListener('click', function () {
          scrollThumbs(1);
        });
      }
      if (thumbsTrack) {
        thumbsTrack.addEventListener('scroll', updateThumbNav, { passive: true });
        window.addEventListener('resize', updateThumbNav);
        updateThumbNav();
        var activeThumb = root.querySelector('[data-thumb].is-active');
        if (activeThumb) scrollThumbIntoView(activeThumb);
      }
    }

    // Fancybox lightbox overlay (never navigate to the image URL)
    function openLightbox(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      var sources = root.querySelectorAll('[data-lightbox-sources] [data-fancybox]');
      if (!sources.length) return false;

      var currentId =
        featured && featured.getAttribute('data-image-id')
          ? featured.getAttribute('data-image-id')
          : '';
      var items = [];
      var startIndex = 0;

      sources.forEach(function (link, i) {
        items.push({
          src: link.getAttribute('href'),
          opts: {
            caption: link.getAttribute('data-caption') || '',
            thumb: link.getAttribute('href'),
          },
        });
        if (String(link.getAttribute('data-lightbox-id')) === String(currentId)) {
          startIndex = i;
        }
      });

      if (!items.length) return false;

      if (
        window.jQuery &&
        window.jQuery.fancybox &&
        typeof window.jQuery.fancybox.open === 'function'
      ) {
        window.jQuery.fancybox.open(items, {
          buttons: ['zoom', 'slideShow', 'thumbs', 'fullScreen', 'close'],
          thumbs: { autoStart: false },
          loop: true,
          protect: true,
          infobar: true,
          arrows: true,
          toolbar: true,
          animationEffect: 'zoom',
          transitionEffect: 'fade',
        }, startIndex);
        return true;
      }

      return false;
    }

    if (featuredLink) {
      featuredLink.setAttribute('role', 'button');
      featuredLink.addEventListener('click', function (event) {
        if (!openLightbox(event)) {
          event.preventDefault();
        }
      });
    }

    scheduleHoverZoom();

    // Retry once scripts finish loading (defer order edge cases)
    if (
      featuredLink &&
      !(
        window.jQuery &&
        window.jQuery.fancybox &&
        typeof window.jQuery.fancybox.open === 'function'
      )
    ) {
      var tries = 0;
      var waitFancy = setInterval(function () {
        tries += 1;
        if (
          window.jQuery &&
          window.jQuery.fancybox &&
          typeof window.jQuery.fancybox.open === 'function'
        ) {
          clearInterval(waitFancy);
        } else if (tries > 40) {
          clearInterval(waitFancy);
        }
      }, 100);
    }

    function clampQty(value) {
      var next = parseInt(value, 10);
      if (isNaN(next) || next < 1) next = 1;
      return next;
    }

    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          qtyInput.value = String(clampQty(Number(qtyInput.value) - 1));
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          qtyInput.value = String(clampQty(Number(qtyInput.value) + 1));
        });
      }
      qtyInput.addEventListener('change', function () {
        qtyInput.value = String(clampQty(qtyInput.value));
      });
    }

    function getVariant(id) {
      if (!product || !product.variants) return null;
      return product.variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function updateKlarna(price) {
      if (!klarnaAmount || !installments) return;
      var share = Math.round(Number(price) / installments);
      klarnaAmount.textContent = formatMoney(share);
    }

    function cleanProductUrl(variantId, updateVariantParam) {
      var params = new URLSearchParams(window.location.search);
      [
        'pr_prod_strat',
        'pr_rec_id',
        'pr_rec_pid',
        'pr_ref_pid',
        'pr_seq',
      ].forEach(function (key) {
        params.delete(key);
      });

      if (updateVariantParam && variantId) {
        params.set('variant', String(variantId));
      } else if (!updateVariantParam) {
        if (!(product && product.variants && product.variants.length > 1)) {
          params.delete('variant');
        }
      }

      var query = params.toString();
      var nextUrl = window.location.pathname + (query ? '?' + query : '');
      var currentUrl = window.location.pathname + window.location.search;
      if (nextUrl !== currentUrl) {
        window.history.replaceState({}, '', nextUrl);
      }
    }

    function updateVariant(variant, options) {
      if (!variant) return;
      var opts = options || {};
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale =
        variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareWrap) {
        if (onSale) {
          compareWrap.hidden = false;
          if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareWrap.hidden = true;
        }
      }
      updateKlarna(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var soldOut = addBtn.dataset.soldOutLabel || 'Sold Out';
        var addLabel = addBtn.dataset.addLabel || 'Add to cart';
        var labelEl = addBtn.querySelector('[data-add-label]');
        if (labelEl) labelEl.textContent = variant.available ? addLabel : soldOut;
      }
      if (variant.featured_image) {
        var matchedThumb = null;
        thumbs.forEach(function (thumb) {
          var active =
            thumb.dataset.imageId === String(variant.featured_image_id || '');
          thumb.classList.toggle('is-active', active);
          if (active) matchedThumb = thumb;
        });
        if (matchedThumb) {
          selectThumb(matchedThumb, true);
        } else {
          setFeatured(variant.featured_image, variant.featured_image_alt || '', {
            imageId: variant.featured_image_id,
            lightboxSrc: variant.featured_image_lightbox || variant.featured_image,
            zoomSrc: variant.featured_image_zoom || variant.featured_image,
          });
        }
      }

      var hasMultipleVariants =
        product && product.variants && product.variants.length > 1;
      if (opts.syncUrl !== false) {
        cleanProductUrl(variant.id, Boolean(hasMultipleVariants && opts.fromUser));
      }
    }

    cleanProductUrl(variantInput && variantInput.value, false);

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateVariant(getVariant(variantSelect.value), {
          syncUrl: true,
          fromUser: true,
        });
      });
      updateVariant(getVariant(variantSelect.value), {
        syncUrl: true,
        fromUser: false,
      });
    } else if (product && product.variants && product.variants.length) {
      var current =
        getVariant(variantInput && variantInput.value) || product.variants[0];
      updateVariant(current, { syncUrl: false });
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-repolished-product-main]')
      .forEach(initProductMain);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-repolished-product-main]');
    if (root) {
      root.dataset.repolishedProductReady = 'false';
      initProductMain(root);
    }
  });
})();
